import React, { useRef } from "react"
import "./Hero.scss"
import parse from "html-react-parser"

/*
@param h1 - Array of Strings, eg. ["Example h1 1", "Example h1 2", ...]
@param h2 - Array of Strings, eg. ["Example h2 1", "Example h2 2", ...]
@param backgroundImage - String, eg. "/static/images/example-image.png"
*/
const Hero = ({ data }) => {
  const { title, video } = data

  const videoRef = useRef(null)

  // // Control video playing
  // const handleOnMouseOverVideo = e => {
  //   if (videoRef.current) {
  //     videoRef.current.play()
  //   }
  // }

  // const handleOnMouseLeaveVideo = () => {
  //   if (videoRef.current) {
  //     videoRef.current.pause()
  //   }
  // }

  return (
    <div
      className="hero-container"
      // onMouseOver={handleOnMouseOverVideo}
      // onMouseLeave={handleOnMouseOverVideo}
      // onFocus={handleOnMouseOverVideo}
      role="button"
      tabIndex={0}
    >
      <div className="text-wrapper">
        <div className="hero-content">{title && parse(title)}</div>
      </div>
      <video
        ref={videoRef}
        src={`${video[0].staticVideo.publicUrl}`}
        muted
        loop
        autoPlay
      />
    </div>
  )
}

export default Hero
